import { Alert, Button, Checkbox, Col, Form, Input, Radio, Row } from "antd";
import React from "react";
import { getMappedData } from "../util";

export default function Acknowledgement() {
  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
        <Alert
          description="Assistance and Data After the Community in Leadership Project is Completed"
          type="info"
        />
        </Col>
      </Row>
      <Row gutter={[24, 0]} style={{marginTop: '20px'}}>
        <Col xs={24} xl={24}>
          <Form.Item name="acknowledge" rules={[{ required: true, message: "Please select an option!" }]} label={"Acknowledgement"}>
              <Radio.Group direction="vertical">
                  <Radio value={'yes'}style={{marginTop: 5}}>{getMappedData("acknowledge_1")}</Radio>
                  <Radio value={'no'} style={{marginTop: 20}}>{getMappedData("acknowledge_2")}</Radio>
              </Radio.Group>
            {/*<Checkbox>*/}
            {/*  {getMappedData("acknowledge_1")}*/}
            {/*</Checkbox>*/}
          </Form.Item>
          {/*<Form.Item name="acknowledge_2" valuePropName="checked">*/}
          {/*  <Checkbox>*/}
          {/*    {getMappedData("acknowledge_2")}*/}
          {/*  </Checkbox>*/}
          {/*</Form.Item>*/}
        </Col>
      </Row>
      <Row gutter={[24, 0]} style={{marginTop: '20px'}}>
        <Col xs={24} xl={24}>
          <Form.Item
              name="ackOtherOptions"
              label="Other Options"
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input />
            </Form.Item>
        </Col>
      </Row>
    </>
  );
}
